import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericContainer} from "../../../components/containers/GenericContainer";
import {ADD_STATE, REMOVE_STATE} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {rolePermissionService, userRoleService} from "../../../jwt/_services";
import {userProvider} from "../../../providers/userProvider";
import {moduleProvider} from "../../../providers/moduleProvider";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import {productPromotionService} from "../../../jwt/_services/promotions/productPromotionService";
import Separator from "../../../components/Separator";

const RolePermissionSection = (props) => {
    const path = props.path + "/permissions";

    const parentState = useSelector((state) => getStateByPath(state, props.path));
    const componentState = useSelector((state) => getStateByPath(state, path));

    const { domainObject } = parentState?.data || false;
    const { listDomainObjects } = componentState?.data || [];
    const { loading } = componentState?.data || false;

    const [moduleId, setModuleId] = useState(null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        };
    }, []);


    useEffect(() => {
        if (!domainObject) return;

        const dataRequest = {
            role: { id: domainObject?.id }
        };

        genericIndexedActions.search(path, rolePermissionService, 0, 1000, dataRequest);
    }, [domainObject]);

    const onAdd = () => {
        const dataRequest = {
            module: { id: moduleId },
            role: { id: domainObject?.id },
            allowSearch : true,
            allowAdd : false,
            allowEdit : false,
            allowDelete : false,
            allowSync : false,
            allowPrices : false,
            allowGallery : false,
            allowSchedule : false,
        }

        genericIndexedActions.save(path, rolePermissionService, dataRequest);
    };


    const onRemove = ( _data ) => {
        const dataRequest = { id: _data?.id  }

        genericIndexedActions.delete(path, rolePermissionService, _data.id, dataRequest);
    };

    const handleStatusChange = (id, _moduleId, data, _status) => {
        let dataRequest = {
            module: { id: _moduleId },
            role: { id: domainObject?.id },
            id : id
        }

        switch (data) {
            case 'ADD':
                dataRequest.allowAdd = _status;
                break;
            case 'EDIT':
                dataRequest.allowEdit = _status;
                break;
            case 'DELETE':
                dataRequest.allowDelete = _status;
                break;
            case 'SYNC':
                dataRequest.allowSync = _status;
                break;
            case 'PRICES':
                dataRequest.allowPrices = _status;
                break;
            case 'GALLERY':
                dataRequest.allowGallery = _status;
                break;
            default:
                dataRequest.allowSearch = true;
                break;
        }

        genericIndexedActions.update(path, rolePermissionService, id, dataRequest)
    }

    const renderContent = ( _option ) => {
        return (
            <div className={'module-menu-item'}>
                <label className="module-menu-item-title">
                    <h3>{_option?.module?.code || ''}</h3>
                </label>
                <div className="permission">
                    <div className="permission-option">
                        <GenericSwitch
                            id={_option?.id}
                            initialState={_option?.allowAdd}
                            onChange={_ => handleStatusChange(_option?.id, _option?.module?.id, 'ADD', !_option?.allowAdd)}
                            labelText={'ADD'}
                        />
                    </div>
                    <div className="permission-option">
                        <GenericSwitch
                            id={_option?.id}
                            initialState={_option?.allowEdit}
                            onChange={_ => handleStatusChange(_option?.id, _option?.module?.id, 'EDIT', !_option?.allowEdit)}
                            labelText={'EDIT'}
                        />
                    </div>
                    <div className="permission-option">
                        <GenericSwitch
                            id={_option?.id}
                            initialState={_option?.allowDelete}
                            onChange={_ => handleStatusChange(_option?.id, _option?.module?.id, 'DELETE', !_option?.allowDelete)}
                            labelText={'DELETE'}
                        />
                    </div>
                    <div className="permission-option">
                        <GenericSwitch
                            id={_option?.id}
                            initialState={_option?.allowSync}
                            onChange={_ => handleStatusChange(_option?.id, _option?.module?.id, 'SYNC', !_option?.allowSync)}
                            labelText={'SYNC'}
                        />
                    </div>
                    <div className="permission-option">
                        <GenericSwitch
                            id={_option?.id}
                            initialState={_option?.allowPrices}
                            onChange={ _ => handleStatusChange(_option?.id, _option?.module?.id, 'PRICES', !_option?.allowPrices)}
                            labelText={'PRICES'}
                        />
                    </div>
                    <div className="permission-option">
                        <GenericSwitch
                            id={_option?.id}
                            initialState={_option?.allowGallery}
                            onChange={_ => handleStatusChange(_option?.id, _option?.module?.id, 'GALLERY', !_option?.allowGallery)}
                            labelText={'GALLERY'}
                        />
                    </div>
                    {/*<div className="permission-option">*/}
                    {/*    <GenericSwitch*/}
                    {/*        id={_option?.id}*/}
                    {/*        initialState={_option?.allowSchedule}*/}
                    {/*        onChange={handleStatusChange}*/}
                    {/*        labelText={'SCHEDULE'}*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
                <div className="float-right">
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={'Desvincular'}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={_ => onRemove(_option)}
                    />
                </div>
            </div>
        )
    }

    return (
        <>
            {/*GENERIC CONTAINER VINCULAR*/}
            <GenericContainer
                listItems={listDomainObjects}
                renderContent={renderContent}
                loading={loading}

                provider={moduleProvider}
                option={moduleId}
                setOption={setModuleId}
                onAddItem={onAdd}
            />
        </>
    );
};

const mapStateToProps = (_) => ({});

const mapActionsToProps = {
    ADD_STATE,
    REMOVE_STATE,
};

export default connect(mapStateToProps, mapActionsToProps)(RolePermissionSection);
